// «На этой установке приложения человека уже спросили про передачу данных AI».
//
// ┌─ Почему на установку, а не на учётную запись ─────────────────────────────┐
// │ App Store второй раз завернул сборку (17.09.2026) по 5.1.1(i) / 5.1.2(i),  │
// │ хотя вопрос в продукте был: экран согласия с дисклеймером об ИИ задаётся   │
// │ один раз на учётную запись. Демо-учётку заранее «подписали» на другом      │
// │ телефоне, и ревьюер на своём iPad вопроса не увидел — значит, для него его │
// │ не было.                                                                  │
// │                                                                          │
// │ Разрешение на передачу данных — про ЭТО устройство и ЭТУ установку: здесь  │
// │ человек только что поставил приложение и ещё ничего не отправлял. Поэтому  │
// │ отметка живёт в хранилище WebView, которое стирается вместе с приложением, │
// │ и ключ включает id пользователя: второй аккаунт на том же телефоне обязан   │
// │ получить свой вопрос (класс «кэш без личности», память                    │
// │ `identity-scoped-state-bugs`).                                            │
// └──────────────────────────────────────────────────────────────────────────┘
//
// Сам ответ хранится на сервере (`users.ai_data_sharing`) и применяется там же;
// здесь — только факт, что на этой установке вопрос уже задан.

const KEY_PREFIX = "studyhub:ai-data-sharing:asked:v1:";

export function wasAskedOnThisInstall(userId: string): boolean {
	try {
		return window.localStorage.getItem(KEY_PREFIX + userId) !== null;
	} catch {
		// Хранилище недоступно — спросим ещё раз. Лишний вопрос безопаснее
		// пропущенного: ответ всё равно берётся с сервера.
		return false;
	}
}

export function markAskedOnThisInstall(userId: string): void {
	try {
		window.localStorage.setItem(KEY_PREFIX + userId, new Date().toISOString());
	} catch {
		// Не записали — вопрос появится при следующем запуске. Решение уже на
		// сервере, так что потерять здесь можно только удобство.
	}
}
